import { cn } from '../../lib/cn';
import type { FulfillmentRow } from '../../customerops/framework';

type Props = { queue?: FulfillmentRow[] };

function priorityColor(priority: string) {
  switch (priority) {
    case 'high': return 'bg-error-100 text-error-700 dark:bg-error-950 dark:text-error-300';
    case 'express': return 'bg-warning-100 text-warning-700 dark:bg-warning-950 dark:text-warning-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function FulfillmentOperationsPanel({ queue = [] }: Props) {
  return (
    <div className="space-y-2">
      {queue.map((f) => (
        <div key={f.order} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{f.order}</p>
            <p className="text-xs text-slate-500">{f.warehouse} · {f.carrier}</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', priorityColor(f.priority))}>
            {f.priority}
          </span>
        </div>
      ))}
    </div>
  );
}
